// extracted by mini-css-extract-plugin
module.exports = {"band":"CategoryChips_band__xVqZI","row":"CategoryChips_row__dsKj2","chip":"CategoryChips_chip__hvTIG"};